import { Component, OnInit, inject, ChangeDetectionStrategy } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { BlockComponent } from "@components/container-block/block.component";
import { PageComponent } from "@components/page/page.component";
import { TabComponent } from "@components/tabs/tab/tab.component";
import { TabsComponent } from "@components/tabs/tabs.component";
import { MatinfoSearchComponent } from "./matinfo/matinfo-search/matinfo-search.component";
import { RedovisningshanvisningSearchComponent } from "./redovisningshanvisning/redovisningshanvisning-search/redovisningshanvisning-search.component";

@Component({
    selector: "rask-regelverk-viol3",
    templateUrl: "./regelverk-viol3.component.html",
    styleUrls: ["./regelverk-viol3.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        PageComponent,
        BlockComponent,
        TabsComponent,
        TabComponent,
        RedovisningshanvisningSearchComponent,
        MatinfoSearchComponent
    ]
})
export class RegelverkViol3Component implements OnInit  {
    inmatningshandelssortiment: string;
    mottagningsplatsnummer: string;

    private readonly route = inject(ActivatedRoute);

    ngOnInit() {
        this.mottagningsplatsnummer = this.route.snapshot.queryParamMap.get("mottagningsplatsnummer");
        this.inmatningshandelssortiment = this.route.snapshot.queryParamMap.get("violId");
    }
}
